import type { ReactElement } from "react";

import type { IFilterViewBaseProps } from "app/pages/sales-intelligence/modules/advanced-search-filtering/types/filterInstance";

import type FindIosDownloadAndEngagementFilter from "../../../../models/IosDownloadAndEngagementFilter/IosDownloadAndEngagementFilter";
import DownloadEngagementFilterResult from "../DownloadEngagementFilterResult";

const AppIosDownloadEngagementFilterResult = ({
    filter,
    value,
    onFilterUpdate,
}: IFilterViewBaseProps<FindIosDownloadAndEngagementFilter>): ReactElement | null => {
    return (
        <DownloadEngagementFilterResult
            filter={filter}
            hasDeviceFilter
            value={value}
            onFilterUpdate={onFilterUpdate}
        />
    );
};

export default AppIosDownloadEngagementFilterResult;
